import { useContext } from 'react';
import { AuthContext, type AuthState } from './AuthContext';

/**
 * Read the live auth state (RBAC R.2b, #314). Must be called within an
 * <AuthProvider>. Returns the authenticated user (or null), the server's
 * enforcement flag, the boot status, and the login/logout/refresh actions.
 */
export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
}
